import React from 'react';
import { Link } from "wouter";
import { Button } from "@/components/ui/button";
import { Calendar } from "lucide-react";
import doctorImage from "@/assets/doctor-image.jpeg";

export default function AboutTheAuthor() {
  return (
    <section id="about-author" className="py-16 bg-indigo-50/70 border-y border-indigo-100">
      <div className="container mx-auto px-4 max-w-5xl">
        <div className="flex flex-col md:flex-row items-start gap-12">
          <div className="md:w-1/3 flex justify-center">
            <div className="relative">
              <div className="relative w-full max-w-[300px] h-[350px] overflow-hidden border border-indigo-800/50 shadow-md mb-6">
                <img 
                  src={doctorImage} 
                  alt="Dr. Anant Vinjamoori" 
                  className="w-full h-full object-cover object-center"
                />
              </div>
            </div>
          </div>
          
          <div className="md:w-2/3">
            <h2 className="text-2xl font-serif font-medium mb-2 text-gray-900">
              About Dr. Anant Vinjamoori
            </h2>
            <div className="h-px bg-indigo-900/30 w-16 mb-6"></div>
            
            <p className="text-base font-medium text-indigo-950 mb-6 leading-relaxed">
              Harvard-trained physician and healthtech operator with a track record of building, scaling, and advising the most innovative healthcare companies in the world.
            </p>
            
            <p className="text-sm text-gray-700 mb-4 leading-relaxed">
              As the Director of Medical Affairs at Virta Health, I helped scale one of the first virtual cardiometabolic clinics 
              in the United States. Later, as Chief Medical Officer at Modern Age, I built one of the first
              national-scale longevity clinics, establishing protocols that have shaped the industry.
            </p>
            
            <p className="text-sm text-gray-700 mb-4 leading-relaxed">
              My clinical training at Harvard Medical School and Brigham & Women's Hospital provides the medical foundation that informs my work.
            </p>
            
            <p className="text-sm text-gray-700 mb-6 leading-relaxed">
              My mission is to bridge the gap between cutting-edge science and practical clinical implementation, making advanced longevity medicine accessible to both patients and practitioners.
            </p>
            
            <div className="flex gap-4">
              <a href="#contact">
                <Button className="bg-indigo-950 text-white hover:bg-indigo-900 text-xs px-4 py-2 rounded-sm h-auto">
                  Get Started
                </Button>
              </a>
              <Link href="/consulting">
                <Button variant="outline" className="border-indigo-950 text-indigo-950 hover:bg-indigo-50 text-xs px-4 py-2 rounded-sm h-auto">
                  Learn More
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}